import {XRow, XText, XCol} from "../../components/xui";
import {searchActions} from "./useSearch";
import {searchCategoriesByKey} from "./search-categories";
import {activeSearchFilterStyles as styles} from "./search.css";
import {DSIconArchive, DSIconClose, Row} from "@cdx/ds";
import {uiStyles} from "@cdx/common";

const HoverClose = ({onClick}) => (
  <XCol
    as="button"
    type="button"
    absolute
    inset="full"
    className={styles.closeHover}
    align="center"
    justify="center"
    onClick={onClick}
  >
    <DSIconClose size={16} />
  </XCol>
);

const FilterPill = ({children, onClose}) => (
  <XRow
    px={1}
    py={0}
    bg="active"
    relative
    title={typeof children === "string" ? children : null}
    rounded="sm"
    noOverflow
  >
    <XText color="active_l4" size={1} noOverflow style={{maxWidth: "8rem"}}>
      {children}
    </XText>
    <HoverClose onClick={onClose} />
  </XRow>
);

const ArchivePill = ({onClick}) => (
  <XRow style={{padding: 2}} bg="gray800" relative rounded="sm" noOverflow>
    <DSIconArchive size={20} className={uiStyles.color.gray300} />
    <HoverClose onClick={onClick} />
  </XRow>
);
const ForceOrPill = ({onClick}) => (
  <XRow px={1} py={0} bg="purple700" relative align="center" rounded="sm" noOverflow>
    <XText preset="bold" color="purple200" size={0}>
      or
    </XText>
    <HoverClose onClick={onClick} />
  </XRow>
);

const ActiveSearchFilters = ({
  filters,
  root,
  includeArchivedCards,
  forceOr,
  onRemoveToken,
  wrap,
}) => (
  <Row sp="4px" wrap={wrap}>
    {includeArchivedCards && (
      <ArchivePill
        onClick={() => {
          searchActions.toggleArchived();
          onRemoveToken();
        }}
      />
    )}
    {forceOr && (
      <ForceOrPill
        onClick={() => {
          searchActions.toggleForceOr();
          onRemoveToken();
        }}
      />
    )}
    {filters.map((filter) => {
      const {category, value} = filter;
      const {valueToKey, renderPill, renderSuggestion} = searchCategoriesByKey[category];
      return (
        <FilterPill
          key={`${category}-${valueToKey(value)}`}
          onClose={() => {
            onRemoveToken(filter);
          }}
        >
          {(renderPill || renderSuggestion)(value, {root})}
        </FilterPill>
      );
    })}
  </Row>
);

export default ActiveSearchFilters;
